import { defineStore } from 'pinia'
import { ref } from 'vue'

import { apiOrdemDeServico } from '@/services/ordemDeServicos'
import { useAlert } from '@/composables/useAlert'
import { useError } from '@/composables/useError'

export const useOrdemDeServico = defineStore('ordemDeServico', () => {
  const { validarErro } = useError()
  const { alertError, alertSucess } = useAlert()
  const { obter, aceitarOuRecusar } = apiOrdemDeServico()

  const loadingObter = ref(false)
  const ordemDeServico = ref(null)
  const loadingAlterar = ref(false)

  const obterOrdemDeServico = async (params) => {
    try {
      loadingObter.value = true
      const resposta = await obter(params)
      ordemDeServico.value = resposta
    } catch (error) {
      ordemDeServico.value = null
    } finally {
      loadingObter.value = false
    }
  }
  const aceitarOuRecusarOrdemDeServico = async (payload) => {
    try {
      loadingAlterar.value = true
      await aceitarOuRecusar(payload)
      return alertSucess('Registro salvo com sucesso.')
    } catch (error) {
      return validarErro(error)
    } finally {
      loadingAlterar.value = false
    }
  }

  return {
    loadingAlterar,
    loadingObter,
    ordemDeServico,
    obterOrdemDeServico,
    aceitarOuRecusarOrdemDeServico
  }
})
